export enum TableContentTypes {
  image,
  colorIcon
}
